export const inIframe = (): boolean => {
  try {
    return window.self !== window.top;
  } catch (e) {
    return true;
  }
};

export const getTopOrigin = (): string | null => {
  const origins = window.location.ancestorOrigins;
  if (origins?.length > 0) {
    return origins[origins.length - 1];
  }
  return null;
};
